export default __webpack_public_path__ + "static/media/KLE.54bb86e2.png";